import React from 'react';
import PropTypes from 'prop-types';
import Svg from "../Svg";

const IconServiceMedical = ({ fill }) => (
	<div className="icon-service icon-service-medical">
		<Svg width={14} height={14} viewBox={'16 16'}>
			<g transform="translate(-8, -8)">
				<path
					d="M17.652153,7.55324326 L17.6515937,14.1032433 L24.6914063,14.1040245 L24.6914063,17.127462 L17.6515937,17.1272433 L17.652153,24.6860558 L14.6287155,24.6860558 L14.6285938,17.1272433 L7.55859375,17.127462 L7.55859375,14.1040245 L14.6285938,14.1032433 L14.6287155,7.55324326 L17.652153,7.55324326 Z"
					fill={fill}
				/>
			</g>
		</Svg>
	</div>
);

IconServiceMedical.defaultProps = {
	fill: '#ffffff'
};

IconServiceMedical.propTypes = {
	fill: PropTypes.string
};

export default IconServiceMedical;
